/**
 * 末端のメニューの画面を開いたら、そのメニューの通知をまとめて既読にする（2026-11-05 ユーザー決定）。
 * 画面には何も出さない。ルーターの中に1つだけ置く（App-NoWallet.jsx）
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { MENU_KEY_BY_PATH, markMenuNotificationsRead, refreshMenuNotificationCounts } from '../utils/menuNotifications.js';

// 同じ画面を行き来しても、続けて何度も既読の要求を出さない
const MIN_INTERVAL_MS = 20 * 1000;

const MenuNotificationReader = () => {
  const { pathname } = useLocation();
  const lastMarkedAt = useRef({});

  useEffect(() => {
    const menuKey = MENU_KEY_BY_PATH[pathname.replace(/\/+$/, '') || '/'];
    if (!menuKey) {
      // 末端のメニューではない画面でも、移動したら件数を取り直す（チャットを読んだあとなど）
      refreshMenuNotificationCounts();
      return;
    }
    const now = Date.now();
    if (now - (lastMarkedAt.current[menuKey] || 0) < MIN_INTERVAL_MS) return;
    lastMarkedAt.current[menuKey] = now;
    markMenuNotificationsRead(menuKey);
  }, [pathname]);

  return null;
};

export default MenuNotificationReader;
